import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { SalesPackage } from 'app/main/models/salespackage/salespackage.model';
import { Softskill } from 'app/main/models/softskill/softskill.model';
import { AgendaService } from 'app/main/services/agenda.service';
import { PurchasedSalesPackageService } from 'app/main/services/purchasedSalesPackage.service';
import { SalesPackageService } from 'app/main/services/salespackage.service';
import { SoftskillService } from 'app/main/services/softskill.service';
import { StudyPlanService } from 'app/main/services/studyPlans.service';
import { SurveyService } from 'app/main/services/survey.service';
import { UtilsService } from 'app/main/services/utils.service';
import { LoaderService } from '../../services/loaderService.service';
import { LocalAccountService } from '../../services/localAccount.service';

@Component({
    selector: 'app-buy-softskill-card',
    templateUrl: './buy-softskill-card.component.html',
    styleUrls: ['./buy-softskill-card.component.scss']
})
export class BuySoftskillCardComponent implements OnInit {

    @Input() salespackage: SalesPackage;
    @Input() softskill: Softskill;

    showNumber: boolean;
    rating: number;
    imageUrl: string;
    canBuy: boolean;
    showGoToBestMatchListButton: boolean;

    constructor(
        private purchasedSalesPackageService: PurchasedSalesPackageService,
        private studyPlanService: StudyPlanService,
        private salesPackageService: SalesPackageService,
        private softskillService: SoftskillService,
        private router: Router,
        private dialog: MatDialog,
        private loaderService: LoaderService,
        private agendaService: AgendaService,
        private utilsService: UtilsService,
        private activatedRoute: ActivatedRoute,
        private localAccountService: LocalAccountService,
        private surveyService: SurveyService
    ) { }

    // tslint:disable-next-line:use-life-cycle-interface
    ngOnChanges(changes: SimpleChanges): void {
        if (changes['softskill']) {
            this.softskill = changes['softskill'].currentValue;
        }
        this.showGoToBestMatchListButton = false;
        this.initialize();
    }

    async ngOnInit() {
        this.canBuy = this.localAccountService.isStudent();
        this.initialize();
        const openModal = this.activatedRoute.snapshot.queryParams.openModal;
        /* if (openModal) {
            this.studentAvailabilityInsertion();
        } */
    }

    initialize() {
        if (this.softskill) {
            //this.rating = this.salespackage.averageValue;
            this.showNumber = true;
            this.imageUrl = this.softskillService.retrieveSoftskillImageUrl(this.softskill);
        }
    }

    goToBestMatchListPage() {
        const softskillNames = new Array<string>();
        softskillNames.push(this.softskill.name);
        this.surveyService.bestMatchForUserWhoHasAlreadyPurchased(softskillNames)
            .then((res: any) => {
                if (res) {
                    if (res.ok) {
                        const extras: NavigationExtras = {
                            state: {
                                response: res,
                                // survey: this.survey,
                                // answers: answers,
                                // softskillNames: softskillNames,
                                // stringifiedAnswers: stringifiedAnswers,
                                // surveyId: this.surveyId
                                survey: null,
                                answers: null,
                                softskillNames: null,
                                stringifiedAnswers: null,
                                surveyId: null
                            }
                        };
                        extras.queryParams = { fromPage: 'studentLogin' };
                        this.router.navigate(['/best-match-area/survey/second-step'], extras);
                        // this.router.navigateByUrl('/best-match-area/survey/second-step?fromPage=' + fromPage);
                    }
                } else {
                    this.utilsService.newErrorSnackbar('C\'e\' stato un errore imprevisto, riprovare');
                }
            })
            .catch((err) => {
                console.error('error', err);
            })
            .finally(() => {
                this.loaderService.hideLoader();
            })
    }

    /* async studentAvailabilityInsertion() {
        if (!this.canBuy) {
            return;
        }
        this.loaderService.showLoader();
        const res: any = await this.studyPlanService
            .getAllowedDegreeCourses()
            .catch(err => {
                console.error(err);
            })
            .finally(() => {
                this.loaderService.hideLoader();
            });
        if (res) {
            if (res.ok) {
                const degreeCoursesAllowed = res.payload;
                const availability = new NewAvailability();
                availability.degreeId = this.subscription.subject.degreeCourse.id;
                availability.subjectId = this.subscription.subject.id;
                const dialogInstance = this.dialog.open(
                    AgendaAvailabilityFormComponent,
                    {
                        width: '400px',
                        maxHeight: '80vh',
                        panelClass: 'custom-panel-class',
                        data: {
                            totalHours: this.subscription.duration,
                            availability,
                            degreeCoursesAllowed,
                            noDegreeCourseAndSubjectSelection: true,
                            subscription: this.subscription,
                            closeModal: async data => {
                                if (data) {
                                    data.subscriptionId = this.subscription.id;
                                    this.loaderService.showLoader();
                                    delete data.endDate;
                                    const res2: any = await this.agendaService
                                        .bestMatch(data)
                                        .catch(err => {
                                            console.error(err);
                                        })
                                        .finally(() => {
                                            this.loaderService.hideLoader();
                                        });
                                    if (res2) {
                                        if (res2.payload) {
                                            if (res2.payload.list.length > 0) {
                                                dialogInstance.close();
                                                this.prepareToBuy(res2.payload);
                                            } else {
                                                this.utilsService.newWarningSnackbar(
                                                    'Nessun docente disponibile'
                                                );
                                            }
                                        }
                                    }
                                } else {
                                    dialogInstance.close();
                                }
                            }
                        }
                    }
                );
            }
        }
    } */

    /* prepareToBuy(payload) {
        if (!this.canBuy) {
            return;
        }
        this.router.navigateByUrl(
            'users-area/best-match/' +
                payload.studentBestMatchRequestId +
                '/prepare-to-buy',
            {
                state: {
                    studentBestMatchRequestId:
                        payload.studentBestMatchRequestId,
                    items: payload.list,
                    subscription: this.subscription
                }
            }
        );
    } */

    /* async createPurchasedSalesPackage() {
        if (!this.canBuy) {
            return;
        }
        // this.purchasedSalesPackageService.createBankTransferPurchasedSalesPackage({ subscriptionId: this.subscription.id });
        // this.purchasedSalesPackageService.refundPayPal('UUID-PRCH-f9d97a41-3637-4e17-9f06-9b6738b442c9');
        this.purchasedSalesPackageService.createPurchasedSalesPackage({
            subscriptionId: this.subscription.id
        });
        // this.purchasedSalesPackageService.createPurchasedSalesPackage({ subscriptionId: this.subscription.id }).then(async (resp: any) => {
        //   const res: any = await this.purchasedSalesPackageService.payWithPayPal(resp.payload.id);
        //   window.open(res.payload.paymentUrlAuthorize, '_blank');
        // });
        // tslint:disable-next-line:max-line-length
        // const res: any = await this.purchasedSalesPackageService.payWithPayPal({ subscriptionId: this.subscription.id, buyerId: 'UUID-USR-a8b75460-4aa1-4956-93d7-a88bc4df8622' });
        // window.open(res.payload.paymentUrlAutorize, '_blank');
    } */

    // async insertStudentAvailability() {
    //   const dialog = this.dialog.open(AgendaAvailabilityFormComponent, {
    //     width: '400px',
    //     maxHeight: '80vh',
    //     panelClass: 'custom-panel-class',
    //     data: {
    //       availability: new NewAvailability(),
    //       degreeCoursesAllowed: this.degreeCoursesAllowed,
    //       closeModal: (data) => {
    //         dialog.close(
    //           {
    //             data
    //           }
    //         );
    //       }
    //     }
    //   });
    //   await dialog.afterClosed().toPromise().then(async (output) => {
    //     if (output && output.data) {
    //       this.saveAvailabilities(output.data);
    //     }
    //   });
    // }

    /* async professorAvailabilityInsertion() {
        this.loaderService.showLoader();
        const res: any = await this.studyPlanService
            .getAllowedDegreeCourses()
            .catch(err => {
                console.error(err);
            })
            .finally(() => {
                this.loaderService.hideLoader();
            });
        if (res) {
            if (res.ok) {
                const degreeCoursesAllowed = res.payload;
                const availability = new NewAvailability();
                availability.degreeId = this.subscription.subject.degreeCourse.id;
                availability.subjectId = this.subscription.subject.id;
                availability.forProfessorCandidation = true;
                const dialog = this.dialog.open(
                    AgendaAvailabilityFormComponent,
                    {
                        width: '400px',
                        maxHeight: '80vh',
                        panelClass: 'custom-panel-class',
                        data: {
                            availability: availability,
                            degreeCoursesAllowed: degreeCoursesAllowed,
                            closeModal: async data => {
                                if (data) {
                                    await this.saveAvailabilities(data);
                                } else {
                                    dialog.close();
                                }
                            }
                        }
                    }
                );
            }
        }
    }
 */
    /* async saveAvailabilities(data) {
        const dialogConfirm = this.dialog.open(AlertComponentComponent, {
            width: '400px',
            maxHeight: '80vh',
            data: {
                innerHTML: true,
                title:
                    'La disponibilit&agrave; creata verr&agrave; inserita all\'interno della tua agenda. ' +
                    'E\' possibile modificare puntualmente le disponibilit&agrave; all\'interno della sezione "Le mie diponibilita\'".',
                buttons: [
                    {
                        text: 'Annulla',
                        color: 'default',
                        close: false,
                        value: false,
                        callback: async () => {
                            dialogConfirm.close();
                        }
                    },
                    {
                        text: 'Conferma disponibilità',
                        color: 'primary',
                        close: true,
                        value: true,
                        callback: async () => {
                            this.loaderService.showLoader();
                            const bool: any = await this.agendaService
                                .newAgendaFromProfessorAvailability(data)
                                .catch(err => {
                                    console.error(err);
                                })
                                .finally(() => {
                                    this.loaderService.hideLoader();
                                });
                            dialogConfirm.close();
                            if (bool) {
                                if (bool.ok) {
                                    // await this.retrieveAllAvailabilities();
                                    this.utilsService.newSuccessSnackbar(
                                        'Disponibilità inserita'
                                    );
                                    this.dialog.closeAll();
                                }
                            }
                        }
                    }
                ]
            }
        });
        // return await dialogConfirm.afterClosed().toPromise();
    } */
}
